const icons = {};

icons.allPurposeCard = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4.5V15.5H15.5V4.5H4.5ZM4 3C3.44772 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16V4C17 3.44772 16.5523 3 16 3H4Z" fill="#3AAF2A" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 19.25V7.25H21V19.25C21 20.2165 20.2165 21 19.25 21H7.25V19.5H19.25C19.3881 19.5 19.5 19.3881 19.5 19.25Z" fill="#3AAF2A" />
</svg>

export default icons;